import Vue from 'vue';
import { mapGetters } from 'vuex';
import EditorLinks from '../editor-links';

export default Vue.component('edit-footer-nav', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['currentSite', 'viewport']),
  },
  components: {
    EditorLinks,
  },
  name: 'edit-footer-nav',
  props: ['droplet', 'show-edit-bubble'],
  methods: {
    setBubbleSize(size) {
      this.$emit('set-bubble-size', size);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/footer-nav/components/_edit-options/index.js